import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class ExportMultipleOrders extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.EXPORT_MULTIPLE_ORDERS]);
  }
}

export default ExportMultipleOrders;
